/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import withBioAttachments from './withBioAttachments';
import AttachmentsField from '../field/AttachmentsField';

/**
 * Custom field component to handle the bio attachments. Paired with the json field within the uiSchema.
 * @param props - form related props injected by the RJSF
 * @returns {function(*)}
 * @constructor
 */
const BioAttachmentsField = (props) => {
  return <>{withBioAttachments(AttachmentsField)(props)}</>;
};
export default BioAttachmentsField;
